import React, { useEffect, useState } from "react";
import FitnessImage from "../../assets/FitnessImage.png";
import FitnessImageTwo from "../../assets/FitnessImageTwo.png";
import SmallFitnessImage from "../../assets/SmallFitnessImage.png";
import SmallFitnessImageTwo from "../../assets/SmallFitnessImageTwo.png";
import "./Home.css"; // Make sure this file exists
import { Link, useNavigate } from "react-router-dom";
import headerfitness1 from "../../assets/banner/header-fitness-1.png";
import headerfitness2 from "../../assets/banner/header-fitness-2.png";
import headerfitness3 from "../../assets/banner/header-fitness-3.png";
import headerfitness4 from "../../assets/banner/header-fitness-4.png";
import headerfitness5 from "../../assets/banner/header-fitness-5.png";

export default function Offline() {
  const navi = useNavigate();
  const images = [
    headerfitness1,
    headerfitness2,
    headerfitness3,
    headerfitness4,
    headerfitness5,
  ];
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const [fadeIn, setFadeIn] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    setFadeIn(true);
  }, []);

  const handleNextImage = () => {
    setFadeIn(false);

    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);

    setTimeout(() => {
      setFadeIn(true);
    }, 1000);
  };
  useEffect(() => {
    const intervalId = setInterval(handleNextImage, 10000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <div>
      {/* <div
        className={
          fadeIn ? "fade-banner-container fade-in" : "banner-container"
        }
      >
        <img
          src={images[currentImageIndex]}
          className={`banner-image ${fadeIn ? "fade-in" : ""}`}
          alt="Banner"
        />
        <div className="banner-text text-center">
          <hr className="title-text"></hr>
          <p className="title-text">Membotic</p>
          <p className="subtitle-text">
            A platform designed for both club owners and users.
          </p>

          <button onClick={() => navi("/register")} className="joinNowButton">
            <a className="fw-bold">Join Now</a>
          </button>

          <hr className="title-text"></hr>
        </div>
      </div> */}
{/* Small screen */}
<div className="row g-0 banner-spacing mt-0 smallScreen w-100 mx-0">


  {/* Left side - Business Use */}
  <div className="col-12 position-relative px-0">
    <img src={FitnessImage} className="w-100" alt="Business Use" />
    <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark opacity-50"></div>
    <div className="position-absolute overlay-content top-50 start-50 translate-middle text-center text-white px-4 px-md-5 w-100 z-1">
      <h2 className="fs-1">Business Use</h2>
      <p className="mb-3 fs-custom">
        Grow your business with Membotic. <br />
        Set up payments, manage schedules, and attract new clients.
      </p>
      <button className="saveChanges-button mt-2 py-2 fs-custom" onClick={() => navi("/clubownerinfo")}>
        Find out more
      </button>
    </div>
  </div>

  {/* Right side */}
  <div className="col-12 position-relative px-0">
    <img src={FitnessImageTwo} className="w-100" alt="Club Users" />
    <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark opacity-50"></div>
    <div className="position-absolute overlay-content top-50 start-50 translate-middle text-center text-white px-4 px-md-5 w-100 z-1">
      <h2 className="fs-1">Join a Club</h2>
      <p className="mb-3 fs-custom">
        Discover clubs near you, book sessions, <br />
        and connect with local trainers.
      </p>
      <button className="saveChanges-button mt-2 py-2 fs-custom" onClick={() => navi("/searchclubs")}>
        Find a Club
      </button>
    </div>
  </div>
</div>



      {/* Big Screen */}
      <div className="row g-0 banner-spacing mt-0  bigScreen">
        {/* Left side - Business Use */}
        <div className="col position-relative">
          <img src={FitnessImage} className="w-100" alt="Business Use" />
          <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark opacity-50"></div>
          <div
            className="position-absolute top-50 start-50 translate-middle text-center text-white px-3"
            style={{ zIndex: 2 }}
          >
            <h2 className="fs-1">Business Use</h2>
            <p className="fs-5">
              Grow your business with Membotic. <br />
              Set up payments, manage schedules, and attract new clients.
            </p>
            <button className="saveChanges-button mt-2 fs-5  py-2" onClick={() => navi("/clubownerinfo")}>
              Find out more
            </button>
          </div>
        </div>

        {/* Right side - Club Users */}
        <div className="col position-relative">
          <img src={FitnessImageTwo} className="w-100" alt="Club Users" />
          <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark opacity-50"></div>
          <div
            className="position-absolute top-50 start-50 translate-middle text-center text-white px-3"
            style={{ zIndex: 2 }}
          >
            <h2 className="fs-1">Join a Club</h2>
            <p className="fs-5">
              Discover clubs near you, book sessions, <br />
              and connect with local trainers.
            </p>
            <button className="saveChanges-button mt-2 fs-5  py-2" onClick={() => navi("/searchclubs")}>
              Find a Club
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
